import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Services } from './components/Services';
import { BeforeAfter } from './components/BeforeAfter';
import { Showcase } from './components/Showcase';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Process } from './components/Process';
import { Kentucky } from './components/Kentucky';
import { Testimonials } from './components/Testimonials';
import { EstimateCTA } from './components/EstimateCTA';
import { EstimateForm } from './components/EstimateForm';
import { Footer } from './components/Footer';
import { MobileCTA } from './components/MobileCTA';
import { ChatWidget } from './components/ChatWidget';
export function App() {
  return <div className="min-h-full w-full bg-cream text-ink" data-id="element-0" data-mp="28tw5arkn8k3g">
      <Navbar data-id="element-1" data-mp="28sbbx5a2f776" />
      <main data-id="element-2" data-mp="23vciyq2516ak">
        <Hero data-id="element-3" data-mp="23vkuoemiy5k6" />
        <TrustBar data-id="element-4" data-mp="23w4gi6fape3h" />
        <Services data-id="element-5" data-mp="23ujjma5idj2g" />
        <BeforeAfter data-id="element-6" data-mp="23v2sz2h3ez4v" />
        <Showcase data-id="element-7" data-mp="23ti5txx3yih1" />
        <WhyChooseUs data-id="element-8" data-mp="3ik7jmqgv0tve" />
        <Process data-id="element-9" data-mp="3iiweonbohg2p" />
        <Kentucky data-id="element-10" data-mp="3ijfw82xf22g7" />
        <Testimonials data-id="element-11" data-mp="3ihv048vgebg8" />
        <EstimateCTA data-id="element-12" data-mp="3mlj6io8cn0zw" />
        <EstimateForm data-id="element-13" data-mp="3mkrefndynled" />
      </main>
      <Footer data-id="element-14" data-mp="3mjq1fdddwou0" />
      <MobileCTA data-id="element-15" data-mp="3mjg8pi0yg3km" />
      <ChatWidget data-id="element-16" data-mp="3rc9co3oln7vn" />
    </div>;
}